<template>
  <div class="row">
    <div class="col">
      <v-calendar
        :attributes="attrs"
        @dayclick="dayClicked"
        show-caps
        is-expanded
        :theme-styles="themeStyles"
        @update:frompage="monthChanged"
        locale='en'
      ></v-calendar>
<!-- :locale="getLang" -->
      <hr />
      <div class="table-responsive">
        <table class="table table-striped">
            <template v-if="lang=='en'">
         <thead >
            <tr>
              <th scope="col">Date</th>
              <th scope="col">Valid until</th>
              <th scope="col">Title</th>
              <th scope="col">Content</th>
            </tr>
          </thead>
              </template>
                <template v-else>
                       <thead >
            <tr>
              <th scope="col">日期</th>
              <th scope="col">有效日期至</th>
              <th scope="col">標題</th>
              <th scope="col">內容</th>
            </tr>
          </thead>

                </template>

          <tbody>
            <tr v-if="filteredItems.length==0">
                <template v-if="lang=='en'">
                    <td  colspan="4" style="text-align:center;">No relevant information</td>
                </template>
                <template v-else>
                    <td colspan="4" style="text-align:center;">暫時沒有相關資料</td>
                </template>
            </tr>
            <tr v-for="item in filteredItems" :key="item.id">
              <th scope="row">{{item.start}}</th>
              <td>{{item.end}}</td>
             <template v-if="lang=='en'">
                <td>{{item.eng_title}}</td>
                <td>{{item.eng_desc}}</td>
            </template>
            <template v-else>
                <td>{{item.title}}</td>
                <td>{{item.desc}}</td>
            </template>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>{ color: '#333333', fontSize: '.8rem', whiteSpace: 'nowrap' }

<script>
export default {
props: [ "lang"],
  data() {
    const hSpacing = "15px";
    return {

      attrs: [],
      items: [],
      filteredItems: [],
      themeStyles: {
        wrapper: {
          // background: 'linear-gradient(to bottom right, #ff5050, #ff66b3)',
          color: "black",
          border: "0",
          // boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.14), 0 6px 20px 0 rgba(0, 0, 0, 0.13)',
          borderRadius: "5px"
        },
        header: {
          padding: `20px ${hSpacing}`
        },
        headerTitle: {
          fontWeight: "blod",
          fontSize: "26px"
        },
        headerArrows: {
          fontWeight: "blod",
          fontSize: "26px"
        },
        dayPopoverHeader: {
          //   fontSize: "46px"
        },
        dayPopoverContent: {
          color: "#333333",
          whiteSpace: "nowrap"
          //   fontSize: "3rem"
        },
        // headerHorizontalDivider: {
        //   borderTop: "solid rgba(255, 255, 255, 0.2) 1px",
        //   width: "80%"
        // },
        weekdays: {
          // color: '#6eded1', // New color
          color: "black",
          fontWeight: "600", // And bolder font weight
          padding: `20px ${hSpacing} 5px ${hSpacing}`,
          fontSize: "20px"
        },
        weeks: {
          padding: `0 ${hSpacing} ${hSpacing} ${hSpacing}`,
          fontSize: "20px"
        },
        dayContent: {
          fontSize: "20px"
        }
      }
    };
  },
  mounted() {
      console.log("lang value ", this.lang);
    // this.init();
  },
  methods: {
    init() {},
    fetchData(year, month) {
      let url = `/calendar/getByMonth/${year}/${month}`;
      axios.get(url).then(res => {
        if (res.data) {
          //   console.log("calendar response data", res.data);
          this.items = res.data;
          this.filteredItems = res.data;
          this.attrs = res.data.map(b => {
            // console.log("map b", b);
            return {
              key: b.id,
              dates: [
                {
                  start: new Date(b.start),
                  end: new Date(b.end)
                }
              ],
              dot: {
                diameter: "8px",
                color: b.backgroundColor
              },
              highlight: {
                backgroundColor: b.backgroundColor,
                height: "2rem",
                borderWidth: "1px"
              },
              contentStyle: {
                color: b.color
              },
              popover: {
                hideIndicator: false,
                label: b.title,
                labelStyle: {
                  fontSize: "20px"
                }
              },
              customData: b
            };
          });
        }
      });
    },

    getLang(){
        if(this.lang == 'en'){
            return 'en';
        }
        return 'zh-HK';
    },
    monthChanged(e) {
      // console.log("month changed", e.month, e.year);
      this.fetchData(e.year, e.month);
    },
    dayClicked(e) {
      // console.log("day dayClicked", e);
      // this.filteredItems = _.filter(this.items, function(o) {
      //     let sDay = new Date(o.start).getDate();
      //     let eDay = new Date(o.end).getDate();
      //           return (sDay <= e.day && eDay >= e.day);
      // });
    }
  }
};
</script>
<style scoped>
table {
  font-size: 16px;
}
</style>








// WEBPACK FOOTER //
// resources/assets/js/mlang/calendar/full-calendar.vue